import axios, { AxiosResponse } from 'axios'
import {
  PrescricaoDtoUtilizacao,
  PrescricaoPacienteView,
} from '../../../apps/atendimento_medicos/prescricao/core/_model'
import { ArquivoDto } from '../../../apps/atendimento/core/_models'

const API_URL = process.env.REACT_APP_API_URL

/**
 * Busca uma prescrição
 * @param token token de acesso da prescrição
 * @param codigo código do paciente
 * @returns PrescricaoPacienteView
 */
export const getPublicPrescricao = (
  token: string,
  codigo?: string
): Promise<PrescricaoPacienteView> => {
  return axios
    .get(`${API_URL}/public/prescricao/${token}${codigo ? `?codigo=${codigo}` : ''}`)
    .then((resp: AxiosResponse<PrescricaoPacienteView>) => resp.data)
}

/**
 *
 * @param codigoAcesso Codigo de acesso
 * @param codigoPaciente Codigo do paciente
 * @returns ArquivoDto
 */
export const downloadAuthPrescricao = (
  codigoAcesso: string,
  codigoPaciente: string
): Promise<ArquivoDto> => {
  return axios
    .get(`${API_URL}/public/prescricao/download/${codigoAcesso}?codigo=${codigoPaciente}`)
    .then((resp: AxiosResponse<ArquivoDto>) => resp.data)
}

/**
 * Download do formulário LME da prescrição (PDF)
 * @param codigoAcesso Codigo de acesso
 * @param codigoPaciente Codigo do paciente
 * @returns ArquivoDto
 */
export const downloadAuthLMEPrescricao = (
  codigoAcesso: string,
  codigoPaciente: string
): Promise<ArquivoDto> => {
  return axios
    .get(`${API_URL}/public/prescricao/download/lme/${codigoAcesso}?codigo=${codigoPaciente}`)
    .then((resp: AxiosResponse<ArquivoDto>) => resp.data)
}

/**
 * Download do formulário APAC da prescrição (PDF)
 * @param codigoAcesso Codigo de acesso
 * @param codigoPaciente Codigo do paciente
 * @returns ArquivoDto
 */
export const downloadAuthAPACPrescricao = (
  codigoAcesso: string,
  codigoPaciente: string
): Promise<ArquivoDto> => {
  return axios
    .get(`${API_URL}/public/prescricao/download/apac/${codigoAcesso}?codigo=${codigoPaciente}`)
    .then((resp: AxiosResponse<ArquivoDto>) => resp.data)
}

export const registerUseOfPrescricao = (
  data: PrescricaoDtoUtilizacao
): Promise<PrescricaoPacienteView> => {
  return axios
    .post(`${API_URL}/public/prescricao/utiliza`, data)
    .then((resp: AxiosResponse<PrescricaoPacienteView>) => resp.data)
}
